// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Ord = require("ord");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var DOM__Search$SmartcutsMacros = require("../devProtocol/DOM__Search.bs.js");
var DOM__Shadow$SmartcutsMacros = require("../DOM__Shadow.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("../DOM__Element.bs.js");
var SelectionSemantics__Shared$SmartcutsMacros = require("./SelectionSemantics__Shared.bs.js");

function t_encode(v) {
  if (typeof v === "number") {
    return ["SelectAll"];
  }
  switch (v.TAG | 0) {
    case /* SelectNthWord */0 :
        return [
                "SelectNthWord",
                Decco.intToJson(v._0)
              ];
    case /* SelectBetweenIndexes */1 :
        return [
                "SelectBetweenIndexes",
                Decco.intToJson(v._0),
                Decco.intToJson(v._1)
              ];
    case /* SelectBetweenNthWords */2 :
        return [
                "SelectBetweenNthWords",
                Decco.intToJson(v._0),
                Decco.intToJson(v._1)
              ];
    case /* SelectBetweenTexts */3 :
        return [
                "SelectBetweenTexts",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1)
              ];
    case /* SelectAfterIndex */4 :
        return [
                "SelectAfterIndex",
                Decco.intToJson(v._0)
              ];
    case /* SelectAfterNthWord */5 :
        return [
                "SelectAfterNthWord",
                Decco.intToJson(v._0)
              ];
    case /* SelectAfterPrefix */6 :
        return [
                "SelectAfterPrefix",
                Decco.stringToJson(v._0)
              ];
    case /* SelectBeforeIndex */7 :
        return [
                "SelectBeforeIndex",
                Decco.intToJson(v._0)
              ];
    case /* SelectBeforeNthWord */8 :
        return [
                "SelectBeforeNthWord",
                Decco.intToJson(v._0)
              ];
    case /* SelectBeforeSuffix */9 :
        return [
                "SelectBeforeSuffix",
                Decco.stringToJson(v._0)
              ];
    
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "SelectAfterIndex" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectAfterIndex */4,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "SelectAfterNthWord" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectAfterNthWord */5,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "SelectAfterPrefix" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectAfterPrefix */6,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "SelectAll" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SelectAll */0
                  };
          }
      case "SelectBeforeIndex" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectBeforeIndex */7,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "SelectBeforeNthWord" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectBeforeNthWord */8,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "SelectBeforeSuffix" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectBeforeSuffix */9,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "SelectBetweenIndexes" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SelectBetweenIndexes */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$6 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$6.path,
                      message: e$6.message,
                      value: e$6.value
                    }
                  };
          }
          var e$7 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "SelectBetweenNthWords" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SelectBetweenNthWords */2,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$8 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$8.path,
                      message: e$8.message,
                      value: e$8.value
                    }
                  };
          }
          var e$9 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "SelectBetweenTexts" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$5.TAG === /* Ok */0) {
            if (match$6.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SelectBetweenTexts */3,
                        _0: match$5._0,
                        _1: match$6._0
                      }
                    };
            }
            var e$10 = match$6._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$10.path,
                      message: e$10.message,
                      value: e$10.value
                    }
                  };
          }
          var e$11 = match$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "SelectNthWord" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectNthWord */0,
                      _0: v0$6._0
                    }
                  };
          }
          var e$12 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function selectInsideInput(element, semantic) {
  var activeElement = DOM__Shadow$SmartcutsMacros.getActiveElementForDocument(undefined);
  if (activeElement !== undefined && Caml_option.valFromOption(activeElement) === element) {
    
  } else {
    element.focus();
  }
  var value = element.value;
  if (typeof semantic === "number") {
    element.setSelectionRange(0, value.length);
    return Promise.resolve({
                TAG: /* Ok */0,
                _0: undefined
              });
  }
  switch (semantic.TAG | 0) {
    case /* SelectNthWord */0 :
        var wordIndex = semantic._0;
        var wordsWithOffsets = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
        var match = Belt_Array.get(wordsWithOffsets, wordIndex);
        if (match !== undefined) {
          var wordOffset = match[0];
          var endOffset = wordOffset + match[1].length | 0;
          element.setSelectionRange(wordOffset, endOffset);
          return Promise.resolve({
                      TAG: /* Ok */0,
                      _0: undefined
                    });
        }
        var nth = wordIndex + 1 | 0;
        return Promise.resolve({
                    TAG: /* Error */1,
                    _0: {
                      TAG: /* CouldNotFindNthWord */0,
                      _0: nth,
                      _1: wordsWithOffsets
                    }
                  });
    case /* SelectBetweenIndexes */1 :
        var endOffset$1 = semantic._1;
        var startOffset = semantic._0;
        var value$1 = element.value;
        if (startOffset > value$1.length) {
          return Promise.resolve({
                      TAG: /* Error */1,
                      _0: {
                        TAG: /* CouldNotFindIndex */1,
                        _0: startOffset,
                        _1: value$1
                      }
                    });
        } else if (endOffset$1 > value$1.length) {
          return Promise.resolve({
                      TAG: /* Error */1,
                      _0: {
                        TAG: /* CouldNotFindIndex */1,
                        _0: endOffset$1,
                        _1: value$1
                      }
                    });
        } else {
          element.setSelectionRange(startOffset, endOffset$1);
          return Promise.resolve({
                      TAG: /* Ok */0,
                      _0: undefined
                    });
        }
    case /* SelectBetweenNthWords */2 :
        var k = semantic._1;
        var i = semantic._0;
        var wordsWithOffsets$1 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
        var match$1 = Belt_Array.get(wordsWithOffsets$1, i);
        var match$2 = Belt_Array.get(wordsWithOffsets$1, k);
        if (match$1 === undefined) {
          return Promise.resolve({
                      TAG: /* Error */1,
                      _0: {
                        TAG: /* CouldNotFindNthWord */0,
                        _0: i,
                        _1: wordsWithOffsets$1
                      }
                    });
        }
        if (match$2 === undefined) {
          return Promise.resolve({
                      TAG: /* Error */1,
                      _0: {
                        TAG: /* CouldNotFindNthWord */0,
                        _0: k,
                        _1: wordsWithOffsets$1
                      }
                    });
        }
        var startOffset$1 = match$1[0] + match$1[1].length | 0;
        element.setSelectionRange(startOffset$1, match$2[0]);
        return Promise.resolve({
                    TAG: /* Ok */0,
                    _0: undefined
                  });
    case /* SelectBetweenTexts */3 :
        var suffix = semantic._1;
        var prefix = semantic._0;
        var prefixIndex = value.indexOf(prefix);
        if (prefixIndex === -1) {
          return Promise.resolve({
                      TAG: /* Error */1,
                      _0: {
                        TAG: /* CouldNotFindPrefix */2,
                        _0: prefix,
                        _1: value
                      }
                    });
        }
        var startOffset$2 = prefixIndex + prefix.length | 0;
        var endOffset$2 = value.indexOf(suffix);
        if (endOffset$2 === -1) {
          return Promise.resolve({
                      TAG: /* Error */1,
                      _0: {
                        TAG: /* CouldNotFindSuffix */3,
                        _0: suffix,
                        _1: value
                      }
                    });
        } else {
          element.setSelectionRange(startOffset$2, endOffset$2);
          return Promise.resolve({
                      TAG: /* Ok */0,
                      _0: undefined
                    });
        }
    case /* SelectAfterIndex */4 :
        var index = semantic._0;
        if (index > value.length) {
          return Promise.resolve({
                      TAG: /* Error */1,
                      _0: {
                        TAG: /* CouldNotFindIndex */1,
                        _0: index,
                        _1: value
                      }
                    });
        } else {
          element.setSelectionRange(index + 1 | 0, value.length);
          return Promise.resolve({
                      TAG: /* Ok */0,
                      _0: undefined
                    });
        }
    case /* SelectAfterNthWord */5 :
        var index$1 = semantic._0;
        var wordsWithOffsets$2 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
        var match$3 = Belt_Array.get(wordsWithOffsets$2, index$1);
        if (match$3 === undefined) {
          return Promise.resolve({
                      TAG: /* Error */1,
                      _0: {
                        TAG: /* CouldNotFindNthWord */0,
                        _0: index$1,
                        _1: wordsWithOffsets$2
                      }
                    });
        }
        var startOffset$3 = match$3[0] + match$3[1].length | 0;
        element.setSelectionRange(startOffset$3, value.length);
        return Promise.resolve({
                    TAG: /* Ok */0,
                    _0: undefined
                  });
    case /* SelectAfterPrefix */6 :
        var prefix$1 = semantic._0;
        var prefixIndex$1 = value.indexOf(prefix$1);
        if (prefixIndex$1 === -1) {
          return Promise.resolve({
                      TAG: /* Error */1,
                      _0: {
                        TAG: /* CouldNotFindPrefix */2,
                        _0: prefix$1,
                        _1: value
                      }
                    });
        }
        var startOffset$4 = prefixIndex$1 + prefix$1.length | 0;
        element.setSelectionRange(startOffset$4, value.length);
        return Promise.resolve({
                    TAG: /* Ok */0,
                    _0: undefined
                  });
    case /* SelectBeforeIndex */7 :
        var index$2 = semantic._0;
        if (index$2 > value.length) {
          return Promise.resolve({
                      TAG: /* Error */1,
                      _0: {
                        TAG: /* CouldNotFindIndex */1,
                        _0: index$2,
                        _1: value
                      }
                    });
        } else {
          element.setSelectionRange(0, index$2);
          return Promise.resolve({
                      TAG: /* Ok */0,
                      _0: undefined
                    });
        }
    case /* SelectBeforeNthWord */8 :
        var index$3 = semantic._0;
        var wordsWithOffsets$3 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
        var match$4 = Belt_Array.get(wordsWithOffsets$3, index$3);
        if (match$4 !== undefined) {
          element.setSelectionRange(0, match$4[0]);
          return Promise.resolve({
                      TAG: /* Ok */0,
                      _0: undefined
                    });
        } else {
          return Promise.resolve({
                      TAG: /* Error */1,
                      _0: {
                        TAG: /* CouldNotFindNthWord */0,
                        _0: index$3,
                        _1: wordsWithOffsets$3
                      }
                    });
        }
    case /* SelectBeforeSuffix */9 :
        var suffix$1 = semantic._0;
        var endOffset$3 = value.indexOf(suffix$1);
        if (endOffset$3 === -1) {
          return Promise.resolve({
                      TAG: /* Error */1,
                      _0: {
                        TAG: /* CouldNotFindSuffix */3,
                        _0: suffix$1,
                        _1: value
                      }
                    });
        } else {
          element.setSelectionRange(0, endOffset$3);
          return Promise.resolve({
                      TAG: /* Ok */0,
                      _0: undefined
                    });
        }
    
  }
}

function selectInsideInputLocatedAtSelector(selector, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
  return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, false, undefined, undefined, undefined, selector).then(function (result_element) {
              if (result_element.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result_element._0
                          });
              }
              var element = result_element._0;
              return DOM__Element$SmartcutsMacros.waitForAnyPossibleOverlayToDisappear(element, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, undefined).then(function (result) {
                          if (result.TAG === /* Ok */0) {
                            return selectInsideInput(element, semantic).then(function (result) {
                                        if (result.TAG === /* Ok */0) {
                                          return Promise.resolve({
                                                      TAG: /* Ok */0,
                                                      _0: undefined
                                                    });
                                        } else {
                                          return Promise.resolve({
                                                      TAG: /* Error */1,
                                                      _0: {
                                                        TAG: /* InputSelectionSemanticError */1,
                                                        _0: result._0
                                                      }
                                                    });
                                        }
                                      });
                          } else {
                            return Promise.resolve({
                                        TAG: /* Error */1,
                                        _0: result._0
                                      });
                          }
                        });
            });
}

function applyToInputValue(value, semantic) {
  if (typeof semantic === "number") {
    return {
            TAG: /* Ok */0,
            _0: value
          };
  }
  switch (semantic.TAG | 0) {
    case /* SelectNthWord */0 :
        var wordIndex = semantic._0;
        var wordsWithOffsets = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
        var match = Belt_Array.get(wordsWithOffsets, wordIndex);
        if (match !== undefined) {
          return {
                  TAG: /* Ok */0,
                  _0: match[1]
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: {
                    TAG: /* CouldNotFindNthWord */0,
                    _0: wordIndex,
                    _1: wordsWithOffsets
                  }
                };
        }
    case /* SelectBetweenIndexes */1 :
        var from = semantic._0;
        if (from > value.length) {
          return {
                  TAG: /* Error */1,
                  _0: {
                    TAG: /* CouldNotFindIndex */1,
                    _0: from,
                    _1: value
                  }
                };
        }
        var to_ = semantic._1;
        if (to_ > value.length) {
          return {
                  TAG: /* Error */1,
                  _0: {
                    TAG: /* CouldNotFindIndex */1,
                    _0: to_,
                    _1: value
                  }
                };
        } else {
          return {
                  TAG: /* Ok */0,
                  _0: StringUtils$SmartcutsMacros.slice(from, to_, value)
                };
        }
    case /* SelectBetweenNthWords */2 :
        var k = semantic._1;
        var i = semantic._0;
        var wordsWithOffsets$1 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
        var match$1 = Belt_Array.get(wordsWithOffsets$1, i);
        var match$2 = Belt_Array.get(wordsWithOffsets$1, k);
        if (match$1 === undefined) {
          return {
                  TAG: /* Error */1,
                  _0: {
                    TAG: /* CouldNotFindNthWord */0,
                    _0: i,
                    _1: wordsWithOffsets$1
                  }
                };
        }
        if (match$2 === undefined) {
          return {
                  TAG: /* Error */1,
                  _0: {
                    TAG: /* CouldNotFindNthWord */0,
                    _0: k,
                    _1: wordsWithOffsets$1
                  }
                };
        }
        var startOffset = match$1[0] + match$1[1].length | 0;
        return {
                TAG: /* Ok */0,
                _0: StringUtils$SmartcutsMacros.slice(startOffset, match$2[0], value)
              };
    case /* SelectBetweenTexts */3 :
        var suffix = semantic._1;
        var prefix = semantic._0;
        var prefixIndex = value.indexOf(prefix);
        if (prefixIndex === -1) {
          return {
                  TAG: /* Error */1,
                  _0: {
                    TAG: /* CouldNotFindPrefix */2,
                    _0: prefix,
                    _1: value
                  }
                };
        }
        var startOffset$1 = prefixIndex + prefix.length | 0;
        var endOffset = value.indexOf(suffix);
        if (endOffset === -1) {
          return {
                  TAG: /* Error */1,
                  _0: {
                    TAG: /* CouldNotFindSuffix */3,
                    _0: suffix,
                    _1: value
                  }
                };
        } else {
          return {
                  TAG: /* Ok */0,
                  _0: StringUtils$SmartcutsMacros.slice(startOffset$1, endOffset, value)
                };
        }
    case /* SelectAfterIndex */4 :
        var index = semantic._0;
        if (index > value.length) {
          return {
                  TAG: /* Error */1,
                  _0: {
                    TAG: /* CouldNotFindIndex */1,
                    _0: index,
                    _1: value
                  }
                };
        } else {
          return {
                  TAG: /* Ok */0,
                  _0: StringUtils$SmartcutsMacros.slice(index + 1 | 0, value.length, value)
                };
        }
    case /* SelectAfterNthWord */5 :
        var index$1 = semantic._0;
        var wordsWithOffsets$2 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
        var match$3 = Belt_Array.get(wordsWithOffsets$2, index$1);
        if (match$3 === undefined) {
          return {
                  TAG: /* Error */1,
                  _0: {
                    TAG: /* CouldNotFindNthWord */0,
                    _0: index$1,
                    _1: wordsWithOffsets$2
                  }
                };
        }
        var startOffset$2 = match$3[0] + match$3[1].length | 0;
        return {
                TAG: /* Ok */0,
                _0: StringUtils$SmartcutsMacros.slice(startOffset$2, value.length, value)
              };
    case /* SelectAfterPrefix */6 :
        var prefix$1 = semantic._0;
        var prefixIndex$1 = value.indexOf(prefix$1);
        if (prefixIndex$1 === -1) {
          return {
                  TAG: /* Error */1,
                  _0: {
                    TAG: /* CouldNotFindPrefix */2,
                    _0: prefix$1,
                    _1: value
                  }
                };
        }
        var startOffset$3 = prefixIndex$1 + prefix$1.length | 0;
        return {
                TAG: /* Ok */0,
                _0: StringUtils$SmartcutsMacros.slice(startOffset$3, value.length, value)
              };
    case /* SelectBeforeIndex */7 :
        var index$2 = semantic._0;
        if (index$2 > value.length) {
          return {
                  TAG: /* Error */1,
                  _0: {
                    TAG: /* CouldNotFindIndex */1,
                    _0: index$2,
                    _1: value
                  }
                };
        } else {
          return {
                  TAG: /* Ok */0,
                  _0: StringUtils$SmartcutsMacros.slice(0, index$2, value)
                };
        }
    case /* SelectBeforeNthWord */8 :
        var index$3 = semantic._0;
        var wordsWithOffsets$3 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
        var match$4 = Belt_Array.get(wordsWithOffsets$3, index$3);
        if (match$4 !== undefined) {
          return {
                  TAG: /* Ok */0,
                  _0: StringUtils$SmartcutsMacros.slice(0, match$4[0], value)
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: {
                    TAG: /* CouldNotFindNthWord */0,
                    _0: index$3,
                    _1: wordsWithOffsets$3
                  }
                };
        }
    case /* SelectBeforeSuffix */9 :
        var suffix$1 = semantic._0;
        var endOffset$1 = value.indexOf(suffix$1);
        if (endOffset$1 === -1) {
          return {
                  TAG: /* Error */1,
                  _0: {
                    TAG: /* CouldNotFindSuffix */3,
                    _0: suffix$1,
                    _1: value
                  }
                };
        } else {
          return {
                  TAG: /* Ok */0,
                  _0: StringUtils$SmartcutsMacros.slice(0, endOffset$1, value)
                };
        }
    
  }
}

function getText(selector, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
  return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, false, undefined, undefined, undefined, selector).then(function (result_element) {
              if (result_element.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result_element._0
                          });
              }
              var element = result_element._0;
              return DOM__Element$SmartcutsMacros.waitForAnyPossibleOverlayToDisappear(element, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, undefined).then(function (result) {
                          if (result.TAG !== /* Ok */0) {
                            return Promise.resolve({
                                        TAG: /* Error */1,
                                        _0: result._0
                                      });
                          }
                          var value = element.value;
                          var str = applyToInputValue(value, semantic);
                          if (str.TAG === /* Ok */0) {
                            return Promise.resolve({
                                        TAG: /* Ok */0,
                                        _0: str._0
                                      });
                          } else {
                            return Promise.resolve({
                                        TAG: /* Error */1,
                                        _0: {
                                          TAG: /* InputSelectionSemanticError */1,
                                          _0: str._0
                                        }
                                      });
                          }
                        });
            });
}

function toHumanReadable(semantic) {
  if (typeof semantic === "number") {
    return "All content inside the form text box";
  }
  switch (semantic.TAG | 0) {
    case /* SelectNthWord */0 :
        var nth = semantic._0 + 1 | 0;
        return "The " + nth + (Ord(nth) + " word");
    case /* SelectBetweenIndexes */1 :
        return "Between position " + semantic._0 + " and " + semantic._1;
    case /* SelectBetweenNthWords */2 :
        var nth$p = semantic._1;
        var nth$1 = semantic._0;
        return "Between " + nth$1 + (Ord(nth$1) + (" and " + nth$p + (Ord(nth$p) + " words")));
    case /* SelectBetweenTexts */3 :
        return "Between \"" + semantic._0 + "\" and \"" + semantic._1 + "\"";
    case /* SelectAfterIndex */4 :
        var nth$2 = semantic._0 + 1 | 0;
        return "After the " + nth$2 + (Ord(nth$2) + " character");
    case /* SelectAfterNthWord */5 :
        var nth$3 = semantic._0;
        return "After the " + nth$3 + (Ord(nth$3) + " word");
    case /* SelectAfterPrefix */6 :
        return "After \"" + semantic._0 + "\"";
    case /* SelectBeforeIndex */7 :
        var nth$4 = semantic._0 + 1 | 0;
        return "Before the " + nth$4 + (Ord(nth$4) + " character");
    case /* SelectBeforeNthWord */8 :
        var nth$5 = semantic._0;
        return "Before the " + nth$5 + (Ord(nth$5) + " word");
    case /* SelectBeforeSuffix */9 :
        return "Before \"" + semantic._0 + "\"";
    
  }
}

var Semantic = {
  t_encode: t_encode,
  t_decode: t_decode,
  selectInsideInput: selectInsideInput,
  selectInsideInputLocatedAtSelector: selectInsideInputLocatedAtSelector,
  applyToInputValue: applyToInputValue,
  getText: getText,
  toHumanReadable: toHumanReadable
};

function t_encode$1(v) {
  return Decco.arrayToJson(t_encode, v);
}

function t_decode$1(v) {
  return Decco.arrayFromJson(t_decode, v);
}

function maybeFromWordsWithPositionsAndToken(wordsWithPositions, selectedString) {
  if (StringUtils$SmartcutsMacros.isToken(selectedString)) {
    return OptionUtils$SmartcutsMacros.map(Belt_Array.getIndexBy(wordsWithPositions, (function (param) {
                      return param[1] === selectedString;
                    })), (function (index) {
                  return {
                          TAG: /* SelectNthWord */0,
                          _0: index
                        };
                }));
  }
  
}

var SelectNthWord = {
  maybeFromWordsWithPositionsAndToken: maybeFromWordsWithPositionsAndToken
};

function fromSelectionStartAndEndAndValue(start, end_, value) {
  var match = SelectionSemantics__Shared$SmartcutsMacros.SemanticsPrefixSuffix.getPrefixAndSuffixWord(value, start, value, end_);
  var suffixWord = match[1];
  var prefixWord = match[0];
  var isStartAtBeginningOfInputValue = start === 0;
  var isEndAtEndOfInputValue = end_ === value.length;
  if (isStartAtBeginningOfInputValue) {
    if (isEndAtEndOfInputValue) {
      return [/* SelectAll */0];
    }
    var words = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
    var index = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(start, words);
    var endCursorAtNthWordStarts;
    if (index !== undefined) {
      var match$1 = Caml_array.get(words, index);
      endCursorAtNthWordStarts = match$1[0] === end_ ? index + 1 | 0 : undefined;
    } else {
      endCursorAtNthWordStarts = undefined;
    }
    var maybeNthWordSemantic = maybeFromWordsWithPositionsAndToken(words, value.slice(start, end_));
    var tmp;
    if (suffixWord !== undefined) {
      var suffix = suffixWord[1];
      tmp = endCursorAtNthWordStarts !== undefined ? [
          {
            TAG: /* SelectBeforeSuffix */9,
            _0: suffix
          },
          {
            TAG: /* SelectBeforeNthWord */8,
            _0: endCursorAtNthWordStarts
          },
          {
            TAG: /* SelectBeforeIndex */7,
            _0: end_
          }
        ] : [
          {
            TAG: /* SelectBeforeSuffix */9,
            _0: suffix
          },
          {
            TAG: /* SelectBeforeIndex */7,
            _0: end_
          }
        ];
    } else {
      tmp = endCursorAtNthWordStarts !== undefined ? [
          {
            TAG: /* SelectBeforeNthWord */8,
            _0: endCursorAtNthWordStarts
          },
          {
            TAG: /* SelectBeforeIndex */7,
            _0: end_
          }
        ] : [{
            TAG: /* SelectBeforeIndex */7,
            _0: end_
          }];
    }
    return $$Array.append(maybeNthWordSemantic !== undefined ? [maybeNthWordSemantic] : [], tmp);
  }
  if (isEndAtEndOfInputValue) {
    var words$1 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
    var index$1 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(start, words$1);
    var startCursorAtNthWordsEnds;
    if (index$1 !== undefined) {
      var match$2 = Caml_array.get(words$1, index$1);
      var wordEnds = match$2[0] + match$2[1].length | 0;
      startCursorAtNthWordsEnds = wordEnds === start ? index$1 : undefined;
    } else {
      startCursorAtNthWordsEnds = undefined;
    }
    var maybeNthWordSemantic$1 = maybeFromWordsWithPositionsAndToken(words$1, value.slice(start, end_));
    var tmp$1;
    if (prefixWord !== undefined) {
      var prefix = prefixWord[1];
      tmp$1 = startCursorAtNthWordsEnds !== undefined ? [
          {
            TAG: /* SelectAfterPrefix */6,
            _0: prefix
          },
          {
            TAG: /* SelectAfterNthWord */5,
            _0: startCursorAtNthWordsEnds
          },
          {
            TAG: /* SelectAfterIndex */4,
            _0: start - 1 | 0
          },
          /* SelectAll */0
        ] : [
          {
            TAG: /* SelectAfterPrefix */6,
            _0: prefix
          },
          {
            TAG: /* SelectAfterIndex */4,
            _0: start - 1 | 0
          },
          /* SelectAll */0
        ];
    } else {
      tmp$1 = startCursorAtNthWordsEnds !== undefined ? [
          {
            TAG: /* SelectAfterNthWord */5,
            _0: startCursorAtNthWordsEnds
          },
          {
            TAG: /* SelectAfterIndex */4,
            _0: start - 1 | 0
          },
          /* SelectAll */0
        ] : [
          {
            TAG: /* SelectAfterIndex */4,
            _0: start - 1 | 0
          },
          /* SelectAll */0
        ];
    }
    return $$Array.append(maybeNthWordSemantic$1 !== undefined ? [maybeNthWordSemantic$1] : [], tmp$1);
  }
  var startWords = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
  var index$2 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(start, startWords);
  var startCursorAtNthWordsEnds$1;
  if (index$2 !== undefined) {
    var match$3 = Caml_array.get(startWords, index$2);
    var wordEnds$1 = match$3[0] + match$3[1].length | 0;
    startCursorAtNthWordsEnds$1 = wordEnds$1 === start ? index$2 : undefined;
  } else {
    startCursorAtNthWordsEnds$1 = undefined;
  }
  var endWords = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
  var index$3 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(start, endWords);
  var endCursorAtNthWordStarts$1;
  if (index$3 !== undefined) {
    var match$4 = Caml_array.get(endWords, index$3);
    endCursorAtNthWordStarts$1 = match$4[0] === end_ ? index$3 : undefined;
  } else {
    endCursorAtNthWordStarts$1 = undefined;
  }
  var maybeNthWordSemantic$2 = maybeFromWordsWithPositionsAndToken(startWords, value.slice(start, end_));
  var tmp$2;
  if (prefixWord !== undefined) {
    if (suffixWord !== undefined) {
      var suffix$1 = suffixWord[1];
      var prefix$1 = prefixWord[1];
      var exit = 0;
      if (startCursorAtNthWordsEnds$1 !== undefined && endCursorAtNthWordStarts$1 !== undefined) {
        tmp$2 = [
          {
            TAG: /* SelectBetweenTexts */3,
            _0: prefix$1,
            _1: suffix$1
          },
          {
            TAG: /* SelectBetweenNthWords */2,
            _0: startCursorAtNthWordsEnds$1,
            _1: endCursorAtNthWordStarts$1
          },
          {
            TAG: /* SelectBetweenIndexes */1,
            _0: start,
            _1: end_
          }
        ];
      } else {
        exit = 1;
      }
      if (exit === 1) {
        tmp$2 = [
          {
            TAG: /* SelectBetweenTexts */3,
            _0: prefix$1,
            _1: suffix$1
          },
          {
            TAG: /* SelectBetweenIndexes */1,
            _0: start,
            _1: end_
          }
        ];
      }
      
    } else {
      tmp$2 = [{
          TAG: /* SelectBetweenIndexes */1,
          _0: start,
          _1: end_
        }];
    }
  } else {
    tmp$2 = [{
        TAG: /* SelectBetweenIndexes */1,
        _0: start,
        _1: end_
      }];
  }
  return $$Array.append(maybeNthWordSemantic$2 !== undefined ? [maybeNthWordSemantic$2] : [], tmp$2);
}

function ofSelection(param) {
  return fromSelectionStartAndEndAndValue(param.start, param.end_, param.value);
}

function stringify(semantics) {
  return "[" + ($$Array.map(toHumanReadable, semantics).join(", ") + "]");
}

exports.Semantic = Semantic;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.SelectNthWord = SelectNthWord;
exports.fromSelectionStartAndEndAndValue = fromSelectionStartAndEndAndValue;
exports.ofSelection = ofSelection;
exports.stringify = stringify;
/* ord Not a pure module */
